<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                       <h3>Basic Info</h3>
                       <v-simple-table>
                           <tbody>
                           <tr>
                               <th class="listHeader tableLinerT" style="width:20%">National</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">
                                   <v-select style="font-size:13px;" class="align-self-center" v-model="COUNTRY_CODE" :items="countryList" item-text="info" item-value="vals" label="Country" outlined dense single-line hide-details></v-select>
                               </td>
                               <th class="listHeader tableLinerT" style="width:20%">Charger Station Name</th>
                               <td class="tableLinerT text-left pl-5" style="width:30%">
                                   <v-text-field v-model="BSS_NM" outlined dense single-line hide-details small placeholder="Charger Station Name"></v-text-field>
                               </td>
                           </tr>
                           <tr>
                               <th class="listHeader">Address</th>
                               <td class="text-left pl-5" colspan="3">
                                   <div class="d-flex flat ">
                                        <div class="mr-3" style="width:100px;">
                                            <v-text-field v-model="POST" outlined dense single-line hide-details small placeholder="post"></v-text-field>
                                        </div>
                                        <div class="mr-3" style="width:45%">
                                            <v-text-field v-model="ADDR1" outlined dense single-line hide-details small placeholder="Address"></v-text-field>
                                        </div>
                                        <div class="mr-5" style="width:45%">
                                            <v-text-field v-model="ADDR2" outlined dense single-line hide-details small placeholder="Address detail"></v-text-field>
                                        </div>
                                        
                                    </div>
                               </td>
                           </tr>
                           <tr>
                               <th class="listHeader">Latitude / Longitude</th>
                               <td class="text-left pl-5" colspan="3">
                                   <div class="d-flex flat ">
                                        <div class="mr-3" style="width:45%">
                                            <v-text-field v-model="LATITUDE" outlined dense single-line hide-details small class="mr-3" placeholder="Latitude"></v-text-field>
                                        </div>
                                        <div class="mr-5" style="width:45%">
                                            <v-text-field v-model="LONGITUDE" outlined dense single-line hide-details small placeholder="Longitude"></v-text-field>
                                        </div>
                                        <v-btn icon @click="geolocateFlag=true"><v-icon>mdi-pencil</v-icon></v-btn>
                                   </div>
                                </td>
                           </tr>                           
                           <tr>
                               <th class="listHeader">Agency</th>
                               <td class="text-left pl-5">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="AGENCY_SEQ" :items="agencyList" item-text="info" item-value="vals" label="Agency" outlined dense single-line hide-details></v-select>
                               </td>
                               <th class="listHeader">Status</th>
                               <td class="text-left pl-5">
                                   <v-select style="font-size:13px;" class="align-self-center" v-model="APRV_STATUS" :items="approvalList" item-text="info" item-value="vals" label="Status" outlined dense single-line hide-details></v-select>
                               </td>
                           </tr>
                           <tr>
                               <th class="listHeader">Registration User</th>
                               <td class="tableLinerB text-left pl-5">
                                   <!--
                                   <v-select style="font-size:13px;" class="align-self-center" v-model="INS_USR_ID" :items="managerList" item-text="info" item-value="vals" label="Manage User" outlined dense single-line hide-details></v-select>
                                   -->
                                   <MngSelect2 @mngID2="mngListUpt2"/>
                               </td>
                               <th class="listHeader tableLinerB">Approval User</th>
                               <td class="tableLinerB text-left pl-5">
                                   <!--
                                   <v-select style="font-size:13px;" class="align-self-center " v-model="APRV_USR_ID" :items="managerList" item-text="info" item-value="vals" label="Manage User" outlined dense single-line hide-details></v-select>
                                   -->
                                   <MngSelect @mngID="mngListUpt"/>
                               </td>
                           </tr>
                           </tbody>
                       </v-simple-table>

                       <h3 class="ma-0 pa-0 mt-5" >Charger &amp; Battery Info</h3>
                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr class="listHeader">
                                    <th class="listHeader tableLinerT">No</th>
                                    <th class="listHeader tableLinerT" >Charger(model)</th>
                                    <th class="listHeader tableLinerT" >Battery1</th>
                                    <th class="listHeader tableLinerT" >Battery2</th>
                                </tr>
                            </thead>
                           <tbody>
                           <tr style="height:43px;">
                               <th class="listHeader tableLinerR tableLinerT" style="width:5%">1</th>
                               <td class="tableLinerT text-left pl-5" style="width:20%">
                                   <v-text-field v-model="selectChargerArr[1]" dense single-line hide-details small readonly clearable  append-outer-icon="mdi-magnify" @click="openDevicePop(1, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT text-left pl-5" style="width:21%">
                                   <v-text-field v-model="selectBatteryArr1[1]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify"  @click="openDevicePop(1, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT text-left pl-5" style="width:21%">
                                   <v-text-field v-model="selectBatteryArr2[1]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(1,3, 2)"></v-text-field>
                               </td>
                           </tr>
                           <tr style="height:43px;">
                               <th class="listHeader tableLinerT" >2</th>
                               <td class="tableLinerT text-left pl-5" >
                                   <v-text-field v-model="selectChargerArr[2]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(2, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[2]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(2, 3,1)"></v-text-field>
                               </td>
                               <td class="tableLinerT text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[2]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(2,3,2)"></v-text-field>
                               </td>
                           </tr> 
                           <tr style="height:43px;">
                               <th class="listHeader tableLinerT" >3</th>
                               <td class="tableLinerT text-left pl-5" >
                                   <v-text-field v-model="selectChargerArr[3]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(3, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT text-left pl-5" >
                                   <v-text-field v-model="selectBatteryArr1[3]" dense single-line hide-details small readonly clearable  append-outer-icon="mdi-magnify" @click="openDevicePop(3, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[3]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(3, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >4</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[4]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(4, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[4]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(4, 3,1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[4]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(4,3,2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >5</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[5]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(5, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[5]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(5, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[5]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(5, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >6</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[6]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(6, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[6]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(6, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[6]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(6, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >7</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[7]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(7, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[7]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(7, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[7]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(7, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >8</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[8]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(8, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[8]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(8, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[8]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(8, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >9</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[9]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(9, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[9]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(9, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[9]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(9, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >10</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[10]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(10, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[10]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(10, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[10]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(10, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >11</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[11]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(11, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[11]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(11, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[11]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(11, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >12</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[12]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(12, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[12]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(12, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[12]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(12, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >13</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[13]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(13, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[13]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(13, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[13]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(13, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >14</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[14]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(14, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[14]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(14, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[14]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(14, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >15</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[15]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(15, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[15]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(15, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[15]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(15, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                          <tr style="height:43px;">
                               <th class="listHeader tableLinerB tableLinerT" >16</th>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectChargerArr[16]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(16, 4)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr1[16]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(16, 3, 1)"></v-text-field>
                               </td>
                               <td class="tableLinerT tableLinerB text-left pl-5">
                                   <v-text-field v-model="selectBatteryArr2[16]" dense single-line hide-details small readonly clearable append-outer-icon="mdi-magnify" @click="openDevicePop(16, 3, 2)"></v-text-field>
                               </td>
                           </tr> 
                           </tbody>
                       </table>

                        <div class="mt-3 pa-5" >
                            <div class="d-flex justify-space-between dense pa-0">
                                <div class="pa2 " >
                                    <v-btn dark class="backBtn px-5" @click="goBack" >Back</v-btn>
                                </div>
                                <div class="pa2 ">
                                    
                                    <v-btn dark class="registerBtn ml-2 px-6" @click="regInfo()">Save</v-btn>
                                </div>
                            </div>
                        </div>
                    </v-card>

                </div>
            </div>
        </div>
        <Footer/>

        <!-- Map -->
        <div class="text-center pb-0 mb-0" width="600">
           <v-dialog v-model="geolocateFlag" width="600">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-3">
                        <span>Map</span>
                    </v-card-title>
                    <v-card-text class="pb-0" style="width:98%; height:400px;">
                        <div >
                            <GmapMap
                                :center="center"
                                :zoom="18"
                                map-style-id="roadmap"
                                
                                style="width: 100%; height: 350px"
                                ref="mapRef"
                                @click="handleMapClick"
                            >
                                <GmapMarker
                                :position="marker.position"
                                :clickable="true"
                                :draggable="true"
                                @drag="handleMarkerDrag"
                                @click="panToMarker"
                                />
                            </GmapMap>
                           <!-- <button @click="geolocate">Detect Location</button> -->
                            <p>Selected Position: {{ marker.position }}</p>
                        </div>
                    </v-card-text>
                    <v-card-actions class="justify-end py-5 pr-10">
                        <v-btn color="red lighten-2" style="color:#fff"  @click="closeGeolocateDialog">Cancel</v-btn>
                        <v-btn color="primary"  @click="addGeolocate()">Apply</v-btn>
                    </v-card-actions>
                </v-card>
           </v-dialog>
        </div>

        <!-- Device List / Select (VCU/MCU/CELL Search Pop) -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="dvcFlag" width="500">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-3">
                        <span>{{schDvcTitle}} List</span>
                    </v-card-title>
                    <v-card-text class="pb-0">
                        <div class="d-flex flat mb-2" style="max-height:38px;" >
                            <div class="d-flex mr-auto align-self-center font-weight-bold text-subtitle-1" >Total <span class="pl-2 listCnt">{{schDvcTotalCnt}}</span></div>
                            <div class="d-flex pr-2">
                                <v-text-field v-model="schDvcID" dense single-line hide-details small :placeholder="schDvcTitle">
                                </v-text-field>
                                <v-btn color="indigo" small class="d-flex align-self-center" icon @click="openDevicePop(selectRow, schDvcClass, selectCls)"><v-icon>mdi-magnify</v-icon></v-btn>
                            </div>
                        </div>
                        <v-simple-table fixed-header height="300px">
                            <thead style="position: sticky !important; top:0;z-index:9999">
                                <th class="listHeader text-center" style="width:60px;background-color:#233446;">No</th>
                                <th class="listHeader text-center" style="width:30%;background-color:#233446;">National</th>
                                <th class="listHeader text-center" style="min-width:50px;background-color:#233446;">Model</th>
                                <th class="listHeader text-center" style="width:50%;background-color:#233446;" colspan="2">{{schDvcTitle}} ID</th>
                            </thead>
                            <tbody>
                                <tr v-for="(item) in schDvcList" :key="item.SEQ">
                                    <td class="tableLinerR tableLinerB text-center pa-0 mr-0" style="width:40px;">
                                        <input type="radio" v-model="selectDvcID" name="vculist" :value="item.DVC_ID" @click="setDvcID(item.DVC_ID)">
                                    </td>
                                    <td class="tableLinerR tableLinerB popText">{{item.NAT_NAME}}</td>
                                    <td class="tableLinerR tableLinerB popText"> - </td>
                                    <td class="tableLinerB text-left pl-5" >
                                        <span @click="setDvcID(item.DVC_ID)">{{item.DVC_ID}}</span>
                                    </td>
                                     <td class="tableLinerB text-right" >
                                        <div class="align-self-center">
                                            <v-btn icon color="red lighten-1" @click="delDvc(schDvcClass, item.DVC_ID);">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="dvcEmptyFlag=='Y'">
                                    <td colspan="5" style="height:80px;">
                                        <div>no data</div>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                    <v-card-actions class="justify-center py-5">
                        <v-btn color="grey lighten-2"  @click="closeDevicePop">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!-- Alert Dialog / Save -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="alertFlag" width="450">
                <v-card>
                    <v-card-title class="text-subtitle-2 pb-0 text-wrap d-flex flat" style="width:450px;">
                        <v-icon class='d-flex' style='color:red;'>mdi-alert </v-icon>
                        <span class="d-flex pl-3">{{alertText}}</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="alertFlag = false;regFlag='Y'">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncSuccess-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncSuccess" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-check-circle </v-icon>
                        <span class="pl-3">It's been processed successfully</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="goList">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">It's been processed failed.</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="asyncErrors=false;">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover { background-color: transparent !important; }
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'
import MngSelect from '@/components/cfgManager.vue'
import MngSelect2 from '@/components/cfgManager2.vue'

export default {
    name: 'BssWrite',
    components: { Gnb, Footer, PageCrumbs,  Navs, MngSelect, MngSelect2 },

    mounted() {
        this.geolocate();
    },
    
    data () {
        return {
             // login Info
            gnbCode:"3", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:12, 
            // Page Title & Breadcrumbs
            pTitles: "New Registration",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Charger', disabled: true,}, { text: 'Charger Management', disabled: true,}, { text: 'New Registration', disabled: false,}],
            NavList: [ 
                        { title: 'Charger Management', nums: '1',
                            items: [ { title: 'Charger List', nums:11, href:'/Bss' , icons:'mdi-format-list-bulleted' },{ title: 'New Registration', nums:12, href:'/BssWrite', icons:'mdi-lead-pencil' },],
                        },
                        { title: 'Charger Log', nums: '2',
                            items: [ { title: 'Charger Log',nums:21, href:'/BssLog', icons:'mdi-format-list-bulleted' },],
                        },
                    ],   
                    
            countryList:[{info: 'Indonesia', vals: "ID"}, {info: 'korea', vals: "KR"}], 
            agencyList: [{info:"indonesia charger", vals:2},{info:"E3Mobility",vals:3}, {info:"Others",vals:4}],
            managerList:[{info:'admin', vals:'admin'},{info:'manager', vals:'manager'}],

            //approvalList: [{info: 'Incoming', vals: 1}, {info: 'Repair', vals: 2}, {info: 'Reception', vals: 3}, {info: 'Disable', vals: 4}, {info: 'Ready', vals: 5}, {info: 'Enable', vals: 6} ],
            approvalList: [ {info: 'Disable', vals: 4}, {info: 'Enable', vals: 6} ],

            asyncActType : "C",
            schSeq:'', schCls:'',

            COUNTRY_CODE: "", COUNTRY_INFO: "",
            AGENCY_SEQ: "", AGENCY_INFO: "", BSS_NM: "", ADDR1: "",
            ADDR2: "", POST: "",
            LATITUDE: "", LONGITUDE: "", BSS_STATUS: "",
            APRV_STATUS: "", APRV_INFO: "",APRV_USR_ID: "", APRV_USR: "", APRV_DTM: "",
            INS_DTM:"", INS_USR_ID:"", INS_USR:"",
            CHRG_MODEL: "", CHRG_ID:"", CELL_IDS:"", CELL_ID1:"", CELL_ID2:"",

            chkListFlag : false,  asyncErrors: false, asyncSuccess: false,
            
            dvcFlag:false,
            schDvcTitle:"",schDvcTotalCnt:0, schDvcID:"",schDvcClass:"", 
            dvcEmptyFlag:false, schDvcList:[],
            selectDvcID:"", 

            selectRow:0, selectCls: 0,
            selectChargerArr:['','','','','','',''], 
            selectBatteryArr1:['','','','','','',''], 
            selectBatteryArr2:['','','','','','',''], 


            alertFlag:false, alertText:"", 

           
            geolocateFlag: false,
            marker: { position: { lat: -6.2188397, lng: 106.8307066  } },
            center: { lat: -6.2188397, lng: 106.8307066  },
            mapOptions: { },
            tmpLat:"", tmpLng: "",
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        //console.log('param 확인' + this.$route.params.Seq +" / "+ this.$route.params.ChrgID);
        this.schSeq = this.$route.params.Seq; 
        this.schChrgID = this.$route.params.ChrgID;
        if(this.schSeq != '' && this.schSeq != undefined && this.schChrgID != '' && this.schChrgID != undefined) {
            this.getInfo();
            //this.getHistory();
            this.asyncActType = "U";
            this.navCode2 = 11;
            this.pTitles = "Edit";
            this.pCrumbs = [ { text: 'Home', disabled: true,}, { text: 'Charger', disabled: true,}, { text: 'Charger Management', disabled: true,},  { text: 'Charger List', disabled: true,}, { text: 'Edit', disabled: false,}];
        } else {
            this.pTitles = "New Registration";
            this.pCrumbs = [ { text: 'Home', disabled: true,}, { text: 'Charger', disabled: true,}, { text: 'Charger Management', disabled: true,}, { text: 'New Registration', disabled: false,}];
        }
        window.scrollTo(0, 0);
        //console.log(this.asyncActType);
    },

    methods : {

        mngListUpt(arg){
            this.APRV_USR_ID = arg;
            //console.log("selectAprvUsr="+this.selectAprvUsr);
        },    

        mngListUpt2(arg){
            this.INS_USR_ID = arg;
            //console.log("selectInsUsr="+this.selectInsUsr);
        },  
        
        //detects location from browser
        geolocate() {
            navigator.geolocation.getCurrentPosition((position) => {
                this.marker.position = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
                };
                this.panToMarker();
            });
        },

        //sets the position of marker when dragged
        handleMarkerDrag(e) {
            this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
        },

        //Moves the map view port to marker
        panToMarker() {
            this.$refs.mapRef.panTo(this.marker.position);
            this.$refs.mapRef.setZoom(18);
        },

        //Moves the marker to click position on the map
        handleMapClick(e) {
            this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            this.tmpLat = e.latLng.lat();
            this.tmpLng = e.latLng.lng();
            //console.log(e);
        },

        closeGeolocateDialog() {
            this.LATITUDE = this.tmpLat = '';
            this.LONGITUDE = this.tmpLng = '';
            this.geolocateFlag = false;
        },

        addGeolocate() {
            this.LATITUDE = this.tmpLat;
            this.LONGITUDE = this.tmpLng;
            this.geolocateFlag = false;
        }, 

        // API Async 
        getInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "bssSeq": this.schSeq
                    , "chrgID": this.schChrgID
                })
            };
            var apiURL = "https://api.e3bss.com/_APP/POC/bssInfo.php"; 
                        
            fetch(apiURL, requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json);
                if(json.result == "success") {
                    this.COUNTRY_CODE = json.COUNTRY_CODE; this.COUNTRY_INFO = json.COUNTRY_INFO; this.AGENCY_SEQ = Number(json.AGENCY_SEQ); 
                    this.AGENCY_INFO = json.AGENCY_INFO;
                    this.BSS_NM = json.BSS_NM; this.ADDR1 = json.ADDR1; this.ADDR2 = json.ADDR2; 
                    this.POST = json.POST; this.LATITUDE = json.LATITUDE; 
                    this.LONGITUDE = json.LONGITUDE;

                    //this.center.lat = (json.LATITUDE);
                    //this.center.lng = (json.LONGITUDE);
                    //this.bands.lat = Number(json.LATITUDE);
                    //this.bands.lng = Number(json.LONGITUDE);
      
                    this.BSS_STATUS = json.BSS_STATUS;
                    
                    this.CHRG_MODEL = json.CHRG_MODEL;
                    this.selectChargerArr[1] = this.CHRG_ID = json.CHRG_ID;
                    this.CELL_IDS = json.CELL_IDS;
                    if(json.CELL_ID1!='') {
                       this.selectBatteryArr1[1] = this.CELL_ID1 = json.CELL_ID1;
                    } else {
                        this.CELL_ID1 = "empty";
                        this.CELL_COLOR1 = "#3F51B5";
                    }
                    if(json.CELL_ID2!='') {
                        this.selectBatteryArr2[1] = this.CELL_ID2 = json.CELL_ID2;
                    } else {
                        this.CELL_ID2 = "empty";
                        this.CELL_COLOR2 = "#3F51B5";
                    }
                    
                    this.APRV_STATUS = Number(json.APRV_STATUS); this.APRV_INFO = json.APRV_INFO;
                    this.APRV_USR_ID = json.APRV_USR_ID; this.APRV_USR = json.APRV_USR; 
                    this.APRV_DTM = json.APRV_DTM;

                    this.INS_DTM = json.INS_DTM; this.INS_USR_ID = json.INS_USR_ID; this.INS_USR = json.INS_USR;
                    
                    this.emptyFlag = false;

                } else {
                   
                    this.emptyFlag = true;
                    
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        // temp : child Error Component
        closeErrorDialog() {
            this.asyncErrors = false;
        },

        // back button
        goBack() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'Bss'});
        },

        goList() {
            this.$router.push({ name: 'Bss'});
        }, 

        setDvcID(vals) {
            if(this.schDvcClass == 3) {
                
                if(this.selectCls == 1) {
                    this.selectBatteryArr1[this.selectRow] = vals;
                } else if(this.selectCls == 2) {
                    this.selectBatteryArr2[this.selectRow] = vals;
                }
                
            } else if(this.schDvcClass == 4) { // charger
                this.selectChargerArr[this.selectRow] = vals;
            }
            this.dvcFlag = false;
            //console.log("click1 = "+ this.selectChargerArr);
            //console.log("click2 = "+ this.selectBatteryArr1);
            //console.log("click3 = "+ this.selectBatteryArr2);
        },

        delDVC(arg1, arg2) {
            console.log(arg1, arg2);
        },

        openDevicePop(idx, arg, cls) {
            //console.log("open - "+ idx, arg, cls);
            if(idx > 0 && arg > 0 ) {
                this.selectRow = idx;
                this.dvcFlag = true;
                this.schDvcClass = arg;
                if(arg == "3") { // battery
                    this.schDvcTitle = "Battery";
                    this.selectCls = cls;
                } else if(arg =="4") { // charger
                    this.schDvcTitle = "Charger";
                }
                var Param = { "usrID": this.loginInfo1
                        , "authCode": this.loginInfo3
                        , "act": "L"
                        , "schDvcClass": arg
                        , "schText": this.schDvcID 
                        , "schExpChrgID": this.selectChargerArr
                        , "schExpCellID1": this.selectBatteryArr1
                        , "schExpCellID2": this.selectBatteryArr2
                    };
                var  requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(Param)
                };

                //console.log("param = "+ JSON.stringify(Param))
                
                fetch('https://api.e3bss.com/_APP/POC/dvcInfo2.php', requestOptions)
                .then((response) => {
                   
                   if(response.ok) {
                        return response.json();
                    }
                    throw new Error('Network response was not ok');
                
                }).then((json) => {

                    //console.log(json);
                    //console.log(json.value.list );
                    if(json.result == "success") {
                        this.schDvcList = json.value.list;
                        this.schDvcTotalCnt = json.totalCnt;
                        this.dvcEmptyFlag = "N";
                    } else {
                        this.schDvcList = [];
                        this.schDvcTotalCnt = 0;
                        this.dvcEmptyFlag = "Y";
                    }
                    this.schDvcID = "";

                }).catch(() => {
                    //console.log(error);
                    this.$router.replace('Error');
                });
            }
        },

        closeDevicePop() {
            this.dvcFlag = false;
        },

        regInfo() {
            if(this.selectCountryCode == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'National');
                return;
            }
            if(this.BSS_NM == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Charger Station Name');
                return;
            }
            if(this.ADDR1 == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'Addressl');
                return;
            }
            if(this.LATITUDE == '' || this.LONGITUDE == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('1', 'LATITUDE / LONGITUDE');
                return;
            }
            if(this.APRV_STATUS == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Status');
                return;
            }
            if(this.INS_USR_ID == '') {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Registration User');
                return;
            }
            /*
            var chkEmptyLength1 = 0, chkEmptyLength2 = 0, chkEmptyLength3 = 0, i=0;
            for(i=0; i<this.selectChargerArr.length; i++) {
                if(this.selectChargerArr[i] == '') chkEmptyLength1++; 
            }
            for(i=0; i<this.selectBatteryArr1.length; i++) {
                if(this.selectBatteryArr1[i] == '') chkEmptyLength2++; 
            }
            for(i=0; i<this.selectChargerArr.length; i++) {
                if(this.selectChargerArr[i] == '') chkEmptyLength3++; 
            }
            if(chkEmptyLength1 > 1 ) {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Charger ID ');
                return;
            }
            if(chkEmptyLength2 > 1 ) {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'Battery ID 1 ');
                return;
            }
            if(chkEmptyLength3 > 1 ) {
                this.regFlag='N'; this.alertFlag=true;
                this.alertToForm('2', 'attery ID 2 ');
                return;
            }
            */
            
            var param =JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": this.asyncActType
                    , "COUNTRY_CODE": this.COUNTRY_CODE, "BSS_NM": this.BSS_NM
                    , "POST": this.post, "ADDR1": this.ADDR1
                    , "ADDR2": this.ADDR2, "LATITUDE": this.LATITUDE
                    , "LONGITUDE": this.LONGITUDE, "AGENCY_SEQ": this.AGENCY_SEQ
                    , "APRV_STATUS": this.APRV_STATUS, "INS_USR_ID": this.INS_USR_ID
                    , "APRV_USR_ID": this.APRV_USR_ID
                    , "CHARGER_IDS":this.selectChargerArr
                    , "BATTERY_IDS1":this.selectBatteryArr1
                    , "BATTERY_IDS2": this.selectBatteryArr2
                    , "bssSeq": this.schSeq
                    , "chrgID": this.schChrgID
                });
            console.log("param="+param);

            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: param
            };
                
            fetch('https://api.e3bss.com/_APP/POC/bssInfo.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                console.log(json);
                //console.log(json.value.list );
                if(json.result == "success") {
                    this.asyncSuccess=true;
                } else {
                    this.asyncErrors = true;
                }  
            })
            .catch(() => {
                this.asyncErrors = true;
                //console.log(error);
            });
        },

        alertToForm(arg1, arg2) {
            var str1 = "enter";
            var strInfo1 = "Please"; var strInfo2 = "information";
            if(arg1 == 2) str1 = 'select';
            this.alertText = strInfo1 +' '+ str1 +' '+ arg2 +' '+ strInfo2+".";
            // Please select country information 
        }

    }

}
</script>
